import { render } from "./promotion_approval_list.vue?vue&type=template&id=0973d1f4&scoped=true"
import script from "./promotion_approval_list.vue?vue&type=script&lang=js"
export * from "./promotion_approval_list.vue?vue&type=script&lang=js"

import "./promotion_approval_list.vue?vue&type=style&index=0&id=0973d1f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0973d1f4"]])

export default __exports__